import { MarketCode } from '../../../types/__generated-graphQL__';
import { useCharityData } from '../../context/charityContext';

const usePaymentLogos = () => {
  const { charity } = useCharityData();

  let largeButtonFilename = 'donate-with-jg-large-payment-logos-gb.svg';
  let paymentTypeLogosFilename = 'payment-type-logos-gb.svg';

  let paymentTypesList =
    'Pay with Mastercard, Visa, American Express, PayPal, Bank Transfer, Apple Pay or Direct Debit.';

  switch (charity?.operatingCompanyCode) {
    case MarketCode.Us:
      largeButtonFilename = 'donate-with-jg-large-payment-logos-us.svg';
      paymentTypeLogosFilename = 'payment-type-logos-us.svg';
      paymentTypesList =
        'Pay with Mastercard, Visa, American Express, PayPal, Venmo or Apple Pay.';
      break;
    case MarketCode.Au:
      largeButtonFilename = 'donate-with-jg-large-payment-logos-au.svg';
      paymentTypeLogosFilename = 'payment-type-logos-au.svg';
      paymentTypesList =
        'Pay with Mastercard, Visa, American Express or PayPal.';
      break;
    case MarketCode.Nz:
      largeButtonFilename = 'donate-with-jg-large-payment-logos-nz.svg';
      paymentTypeLogosFilename = 'payment-type-logos-nz.svg';
      paymentTypesList =
        'Pay with Mastercard, Visa, American Express or PayPal.';
      break;
    case MarketCode.Gb:
    default:
      break;
  }

  return {
    largeButtonFilename,
    paymentTypeLogosFilename,
    paymentTypesList,
  };
};

export default usePaymentLogos;
